<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.74797 10.2273C2.70867 10.3442 2.68186 10.4648 2.66797 10.5873V25.334C2.66797 26.3948 3.0894 27.4123 3.83954
      28.1624C4.58969 28.9126 5.6071 29.334 6.66797 29.334H12.0013C12.7377 29.334 13.3346 28.737 13.3346 28.0007C13.3346
      27.2643 12.7377 26.6673 12.0013 26.6673H6.66797C6.31435 26.6673 5.97521 26.5268 5.72516 26.2768C5.47511 26.0267
      5.33464 25.6876 5.33464 25.334V12.0007H12.0013C12.3549 12.0007 12.6941 11.8602 12.9441 11.6101C13.1942 11.3601
      13.3346 11.0209 13.3346 10.6673V4.00065H26.668C27.4043 4.00065 28.0013 3.4037 28.0013 2.66732C28.0013 1.93094
      27.4043 1.33398 26.668 1.33398H11.9213L11.4946 1.48065H11.3746C11.2375 1.54476 11.1115 1.63027 11.0013
      1.73398L3.0013 9.73398C2.89759 9.8442 2.81208 9.97022 2.74797 10.1073V10.2273ZM7.21463 9.33399L10.668
      5.88065V9.33399H7.21463ZM17.3346 6.66732C16.5983 6.66732 16.0013 7.26427 16.0013 8.00065V29.334C16.0013 30.0704
      16.5983 30.6673 17.3346 30.6673H28.0013C28.7377 30.6673 29.3346 30.0704 29.3346 29.334V8.00065C29.3346 7.26427
      28.7377 6.66732 28.0013 6.66732H17.3346ZM18.668 9.33399V28.0007H26.668V25.334H22.668C21.9316 25.334 21.3346 24.737
      21.3346 24.0007C21.3346 23.2643 21.9316 22.6673 22.668 22.6673H26.668V20.0007H25.3346C24.5983 20.0007 24.0013
      19.4037 24.0013 18.6673C24.0013 17.9309 24.5983 17.334 25.3346 17.334H26.668V14.6673H22.668C21.9316 14.6673
      21.3346 14.0704 21.3346 13.334C21.3346 12.5976 21.9316 12.0007 22.668 12.0007H26.668V9.33399H18.668Z"
    />
  </svg>
</template>
